import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'libs/core/src/lib/environments/environment';

@Injectable({ providedIn: 'root' })
export class RouteTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    const title = this.buildTitle(routerState);
    if (title !== undefined) {
      // portalName (not name) - it's the display string TenantConfigService updates at runtime,
      // while `name` stays a static build-time identifier some route guards branch on.
      this.title.setTitle(`${environment.portalName} | ${title}`);
    }
  }
}
